module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_09.f7bdf6e9.jpg";